export const TOP_YMAL = 'topYMAL'
export const SORT_BY_LOCATIONS = 'sortByLocations'
export const SORT_BY_HOLIDAY_TYPES = 'sortByHolidayTypes'
